import React from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";

import { useDispatch, useSelector } from "react-redux";
import { getMyDonationCollection } from "../../../CreateCollection/slice";
import DonationCollectionCard from "./DonationCollectionCard";
import Loader from "../../../../components/Loader";
const DonationCollection = ({ donationId, t }) => {
  const [offset, setOffSet] = React.useState(0);
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const {
    collection: { myDonationCollections, loading },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const getCollections = async (data) => {
    const payload = {
      ...data,
    };
    dispatch(getMyDonationCollection(payload));
  };

  const handleChange = (event, value) => {
    let limit = 10;
    let offset = 0;
    if (value > 1) {
      limit = value * 10;
      offset = limit - 10;
    }
    setPage(value);
    setOffSet(offset);
    setLimit(limit);
    const data = {
      offset: offset,
      limit: limit,
      donationId: donationId,
    };
    getCollections(data);
  };

  React.useEffect(() => {
    const data = {
      offset: offset,
      limit: limit,
      donationId: donationId,
    };
    getCollections(data);
  }, [donationId]);

  return (
    <>
      {loading && (
         <Loader phrase={"A carregar reservas"} t={t} />
        
      )}
      {!loading &&
        myDonationCollections?.collectionDetails?.length > 0 &&
        myDonationCollections?.collectionDetails.map((item) => (
          <DonationCollectionCard
            collection={item}
            t={t}
            key={item.collection.id}
          />
        ))}
      {!loading && myDonationCollections?.collectionDetails?.length > 0 && (
        <Stack spacing={2} alignItems={"center"}>
          <Pagination
            count={myDonationCollections?.count}
            variant="outlined"
            color="primary"
            onChange={handleChange}
            page={page}
          />
        </Stack>
      )}
    </>
  );
};

export default DonationCollection;
